// extracted by mini-css-extract-plugin
module.exports = {"notif":"App_notif__VdoT7"};